import {API_ROUTE_AUTHENTICATION} from "../../../back-end/constants/API-ROUTES.js";
import {post} from "./_fetch.js";

export const postAuthApi = (username, password) => post(API_ROUTE_AUTHENTICATION, { username, password })